<!--
  -- 配药
  -->

<template>
  <div class="flex flex-col">
    <!--  表单 start  -->
    <prepare-med-form />
    <!--  表单 end  -->
    <div class="flex flex-col">
      <div class="label-con flex flex-row align-center">
        <div class="icon" />
        <div class="label">清单</div>
      </div>
      <prepare-med-list />
    </div>
  </div>
</template>

<script>
import PrepareMedForm from "@/views/business/page/treatment/treatment/treatment/PrepareMedForm.vue"
import PrepareMedList from "@/views/business/page/treatment/treatment/treatment/PrepareMedList.vue"

export default {
  name: "PrepareMed",
  components: { PrepareMedList, PrepareMedForm }
}
</script>

<style scoped lang="scss">

.label-con {
  margin-bottom: 12px;

  .icon {
    width: 4px;
    height: 14px;
    background: #165DFF;
    border-radius: 0 0 0 0;
    margin-right: 8px;
  }

  .label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bold;
    font-size: 16px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
